import { useLanguage } from '../contexts/LanguageContext';
import { interfaceText } from '../locales/interfaceTranslations';
import { autoTranslate } from '../locales/autoTranslate';
export function useInterfaceText(){
 const {language}=useLanguage();
 const ui=text=>{const translated=interfaceText(text,language);return translated===text?autoTranslate(text,language):translated;};
 ui.locale={es:'es-ES',en:'en-US',pt:'pt-BR',fr:'fr-FR'}[language]||'en-US';
 return ui;
}
export default function InterfaceText({text}){const ui=useInterfaceText();return ui(text);}
